<template>
    <span @mouseenter="handleShowTooltip($event)">
        <el-tooltip :disabled="showTooltip" :content="sendTooltipInfo" placement="top"
                    :open-delay="300">
            <div class="tootip-style">{{sendTooltipInfo}}</div>
        </el-tooltip>
    </span>
</template>

<script>
    export default {
        data() {
            return {
                showTooltip:false
            }
        },
        props: ['sendTooltipInfo'],
        methods:{
            handleShowTooltip(event){
                let cell = event.target.querySelector('.el-tooltip');
                this.showTooltip = cell.scrollWidth === cell.offsetWidth && cell.scrollHeight === cell.offsetHeight;
             /*   this.$exit('returnTooltipInfo',{
                    showTooltip: this.showTooltip
                })*/
            },
        }
    }
</script>

<style>
    .tootip-style{
        overflow:hidden;
        white-space:nowrap;
        text-overflow:ellipsis;
        -o-text-overflow:ellipsis;
        -icab-text-overflow: ellipsis;
        -khtml-text-overflow: ellipsis;
        -moz-text-overflow: ellipsis;
        -webkit-text-overflow: ellipsis;
    }
    .el-tooltip__popper {
        max-width: 350px;
        word-break: break-all;
    }
</style>
  


// WEBPACK FOOTER //
// TooltipHint.vue?76ff220d